import { useRegisterContext } from '@contexts/RegisterProvider';

import { CheckRegistrationLink } from './CheckRegistrationLink';
import RegistrationCodeForm from './RegistrationCodeForm';

const RegistrationCode: React.FC = () => {
  const { hasInitialCode } = useRegisterContext();

  return hasInitialCode ? <CheckRegistrationLink /> : <RegistrationCodeForm />;
};

export default RegistrationCode;
